"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _iconElement = require("../../fuse-icon-element/src/icon-element");
var titleSizeConfig = {
  // heading sizes NOT viewport size
  heading: {
    xxsmall: '1',
    xsmall: '2',
    small: '3',
    medium: '4',
    large: '5',
    xlarge: '6'
  },
  // icon sizes NOT viewport size
  icon: {
    xxsmall: _iconElement.iconElementConfig.small.height,
    // 24px
    xsmall: _iconElement.iconElementConfig.small.height,
    // 24px
    small: _iconElement.iconElementConfig.small.height,
    // 24px
    medium: _iconElement.iconElementConfig.medium.height,
    // 32px
    large: _iconElement.iconElementConfig.large.height,
    // 40px
    xlarge: _iconElement.iconElementConfig.large.height // 40px
  }
};
var _default = exports["default"] = titleSizeConfig;